module.exports = __webpack_public_path__ + "static/media/ic213epromedit.28aff480.jpg";